import {
  Button,
  Flex,
  Heading,
  Text,
  Image,
  Link,
  Highlight,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { StarIcon } from '@chakra-ui/icons';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import Container from '../common/container';
import AppImage from '../assets/push-training-app.png';
import RedeemShareCodeExample from '../assets/redeem-code.png';
import {
  PushInfo,
  getPushAppInfoFromApple,
} from '../api/getPushAppInfoFromApple';
import {
  trackSendToAppDownloadButtonTapped,
  trackShareCodePageView,
} from '../utils/analytics';
import { ShareCode, useLookupShareCode } from '../api/shareCodes';

const ShareCodePage = observer(() => {
  const { shareCodeValue } = useParams();
  const [pushInfo, setPushInfo] = useState<PushInfo>({
    trackName: 'Treadmill Workout Push Training',
    averageUserRating: 4.9,
    userRatingCountForCurrentVersion: 590,
    artworkUrl512: AppImage,
  });
  const { lookupShareCode, isLoading, error } = useLookupShareCode();
  const [shareCode, setShareCode] = useState<ShareCode | null>(null);

  useEffect(() => {
    trackShareCodePageView(shareCodeValue);

    if (shareCodeValue) {
      lookupShareCode(shareCodeValue).then((result) => {
        if (result) {
          setShareCode(result.shareCode);
        }
      });
    }

    getPushAppInfoFromApple().then((result) => {
      setPushInfo({
        trackName: result.trackName,
        averageUserRating: result.averageUserRating,
        userRatingCountForCurrentVersion:
          result.userRatingCountForCurrentVersion,
        artworkUrl512: result.artworkUrl512,
      });
    });
  }, []);

  if (isLoading) {
    return (
      <Container>
        <Text textAlign={'center'} marginTop={'5'}>
          Loading...
        </Text>
      </Container>
    );
  }

  if (error || !shareCode) {
    return (
      <Container>
        <Heading textAlign={'center'} marginTop={'5'}>
          Sorry
        </Heading>
        <Text textAlign={'center'} marginTop={'5'}>
          {error}
        </Text>
      </Container>
    );
  }

  return (
    <Container>
      <Heading textAlign={'center'} marginTop={'5'}>
        Steps to Redeem
      </Heading>
      <Link
        href="/download?ct=webShareCode"
        _hover={{ textDecoration: 'none' }}
        onClick={() => {
          trackSendToAppDownloadButtonTapped('webShareCode', shareCodeValue);
        }}
      >
        <Flex margin={'5'} direction={'column'}>
          <Text marginTop={'5'} fontSize={'20px'} as={'b'}>
            1. Download the app
          </Text>
          <Flex direction={'row'} alignItems={'center'}>
            <Image
              src={pushInfo.artworkUrl512}
              borderRadius={'2xl'}
              backgroundColor={'dripSecondaryFill'}
              width={'60px'}
              marginTop={'2'}
            ></Image>
            <Flex direction={'column'} marginLeft={'3'} flexShrink={'2'}>
              <Text fontSize={'18px'}>Treadmill Workout Push Training</Text>
              <Text fontSize={'14px'} color={'lightGray'}>
                Interval run timer and coach
              </Text>
            </Flex>
            <Button
              bgColor={'tintColor'}
              marginLeft={'5'}
              borderRadius={'2xl'}
              color={'white'}
              height={'30px'}
            >
              Open
            </Button>
          </Flex>
          <Flex
            direction={'row'}
            marginTop={'5'}
            justifyContent={'space-between'}
          >
            <Flex alignItems={'center'} color={'lightGray'}>
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <Text marginLeft={'1'} color={'lightGray'}>
                {pushInfo.userRatingCountForCurrentVersion}
              </Text>
            </Flex>
            <Text marginRight={'3'} color={'lightGray'}>
              Health & Fitness
            </Text>
          </Flex>
        </Flex>
      </Link>
      <Flex direction={'column'} margin={'5'}>
        <Text marginTop={'5'} fontSize={'20px'} as={'b'}>
          2. Enter the code{' '}
          <Highlight
            query={shareCodeValue ?? ''}
            styles={{
              px: '2',
              py: '1',
              rounded: '4',
              bg: 'gray',
              color: 'white',
            }}
          >
            {shareCodeValue ?? ''}
          </Highlight>
        </Text>
        <Text color={'lightGray'}>
          Tap on the gift icon on the first page or in the Profile tab.
        </Text>
      </Flex>

      <Flex
        justifyContent={'center'}
        marginLeft={'5'}
        marginRight={'5'}
        marginBottom={'50'}
      >
        <Image src={RedeemShareCodeExample} width={'100%'}></Image>
      </Flex>
    </Container>
  );
});

export default ShareCodePage;
